export const dbPanels = {
  images: {
    subtitle: `Laden Sie Fotos hoch, sortieren Sie sie und legen Sie das Hauptfoto jeder Einheit fest, das in Ihrer Buchungsmaschine angezeigt wird.`,
  },

  amenities: {
    searchPlaceholder: `Ausstattung suchen…`,
    selectedCount: `{count} Ausstattung ausgewählt | {count} Ausstattungen ausgewählt`,
    noResults: `Keine Ergebnisse für "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `Der Agent zeigt sie jedem Gast, der nach dieser Ausstattung fragt.`,
      dropTitle: `Fotos hierher ziehen`,
      addPhotos: `Fotos hinzufügen`,
      dropHint: `JPG, PNG, WebP oder HEIC · bis {mb} MB pro Datei`,
      dropActive: `Loslassen zum Hochladen`,
      uploading: `Wird hochgeladen… {progress} %`,
      uploaded: `{count} Foto hinzugefügt | {count} Fotos hinzugefügt`,
      counter: `{count} Foto | {count} Fotos`,
      remaining: `Noch {count} Foto möglich | Noch {count} Fotos möglich`,
      full: `Das Maximum von {max} Fotos ist erreicht`,
      tooMany: `Pro Ausstattung passen nur {max} Fotos.`,
      tooHeavy: `„{name}“ ist größer als {mb} MB. Bitte vorher verkleinern.`,
      notImage: `„{name}“ ist kein Bild.`,
      uploadError: `Die Fotos konnten nicht hochgeladen werden.`,
      removeAria: `Dieses Foto entfernen`,
      deleteTitle: `Dieses Foto entfernen?`,
      deleteBody: `Der Agent zeigt es nicht mehr, wenn nach „{amenity}“ gefragt wird. Das lässt sich nicht rückgängig machen.`,
      deleteCancel: `Abbrechen`,
      deleteConfirm: `Foto entfernen`,
      deleted: `Foto entfernt`,
      deleteError: `Das Foto konnte nicht entfernt werden.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `Der Agent zeigt die ersten {count}. Zum Umsortieren am Griff ziehen.`,
      dragTitle: `Zum Sortieren ziehen`,
      reordering: `Reihenfolge wird gespeichert…`,
      orderSaved: `Reihenfolge gespeichert`,
      orderError: `Die Reihenfolge konnte nicht gespeichert werden.`,
      willSend: `Der Agent sendet dieses Foto`,
      wontSend: `Bis zu diesem Foto kommt der Agent nicht`,
      someFailed: `Konnten nicht verarbeitet werden: {names}`,
    },
  },

  occupancy: {
    question: `Welche Anpassung möchten Sie anwenden?`,
    questionRoom: `Welche Anpassung möchten Sie auf dieses Zimmer anwenden?`,
    modeNone: `Keine`,
    modeReduction: `Ermäßigung`,
    modeSurcharge: `Aufschlag`,
    baseOccupancy: `Basisbelegung`,
    baseHint: `Gäste (der Standardpreis)`,
    thOccupancy: `Belegung`,
    thRule: `Regel`,
    thValue: `Wert`,
    thActive: `Aktiv`,
    guestsCount: `{count} Gast | {count} Gäste`,
    ruleReductionPct: `Ermäßigung %`,
    ruleReductionFixed: `Ermäßigung {currency}`,
    reductionInfo: `Bei weniger Gästen als der Basisbelegung gilt diese Ermäßigung auf den Preis der Unterkunft.`,
    priceIncludes: `Im Preis enthalten`,
    guestsCapacity: `Gast (Zimmerkapazität) | Gäste (Zimmerkapazität)`,
    maxExtraGuests: `Max. Zusatzgäste`,
    chargePerExtraGuest: `Gebühr pro Zusatzgast`,
    chargeFixed: `{currency} fix`,
    perNight: `pro Nacht`,
    surchargeInfo: `Jeder Gast über der enthaltenen Kapazität zahlt diese Gebühr pro Nacht.`,
    noneRoom: `Für dieses Zimmer gibt es keine Belegungsanpassung: derselbe Preis für jede Gästezahl (innerhalb der Kapazität).`,
    noneBooking: `Für diese Buchung gibt es keine Belegungsanpassung: derselbe Preis für jede Gästezahl (innerhalb der Kapazität).`,
  },

  share: {
    title: `Teilen (Hotel)`,
    desc: `Dieser Link gilt speziell für dieses Hotel. Teilen Sie ihn über WhatsApp oder öffnen Sie ihn als Besucher.`,
    linkLabel: `Buchungslink des Hotels`,
    linkHint: `Verwenden Sie ihn in Ihrer Bio, in Kampagnen oder in automatischen Nachrichten.`,
    viewAsVisitor: `Als Besucher ansehen`,
    tip: `Tipp: Sie können diesen Link zusammen mit Ihrer Buchungsbestätigung senden.`,
    noLinkCopy: `Kein Link zum Kopieren.`,
    copied: `Link kopiert.`,
    copyError: `Der Link konnte nicht kopiert werden.`,
    noLinkShare: `Kein Link zum Teilen.`,
    whatsappMsg: `Hallo 👋 Hier ist der Link, um in diesem Hotel zu buchen: {link}`,
    noLinkOpen: `Kein Link zum Öffnen.`,
  },

  unitServices: {
    title: `Ausstattung und Annehmlichkeiten`,
    subPrefix: `Ausstattung für`,
    thisRoom: `dieses Zimmer`,
    subInfo: `Jeder Zimmertyp hat seine eigene; Direktbuchung und KI-Agent verwenden die des Zimmers, das dem Gast zugewiesen ist.`,
    loading: `Ausstattung wird geladen…`,
    loadError: `Die Ausstattung dieses Zimmers konnte nicht geladen werden.`,
    retry: `Erneut versuchen`,
    saving: `Wird gespeichert…`,
    saved: `Gespeichert`,
    autosaveHint: `Änderungen werden beim An- und Abwählen automatisch gespeichert.`,
  },

  welcome: {
    tag: `Direktbuchungsmaschine`,
    titleA: `Buchungen erhalten`,
    titleHighlight: `ohne Provision`,
    sub: `Ihre eigene Buchungsmaschine pro Unterkunft: Link teilen, der Gast bucht und zahlt direkt. Keine Zwischenhändler, keine OTA-Provisionen.`,
    howItWorks: `So funktioniert es`,
    benefits: `Vorteile`,
    step1Title: `Teilen Sie Ihren Link`,
    step1Text: `Jede Unterkunft hat ihren eigenen Link. Posten Sie ihn auf Ihrer Website, in sozialen Netzwerken oder auf WhatsApp; der KI-Agent sendet ihn auch an Interessenten.`,
    step2Title: `Der Gast bucht`,
    step2Text: `Er wählt die Daten und zahlt in Ihrer Buchungsmaschine. Die Buchung landet direkt in Ihrem Kalender, ohne OTA-Provisionen.`,
    step3Title: `Sie werden direkt bezahlt`,
    step3Text: `Erhalten Sie Zahlungen ohne Zwischenhändler und fügen Sie jedem Aufenthalt Aktionen, Gebühren und Zusatzservices hinzu.`,
    ctaStart: `Mit der Einrichtung beginnen`,
    ctaPromotions: `Globale Aktionen ansehen`,
    perk1Title: `Null OTA-Provisionen`,
    perk1Text: `Behalten Sie 100 % jeder Direktbuchung.`,
    perk2Title: `Sofortige Zahlung und Bestätigung`,
    perk2Text: `Der Gast zahlt und die Buchung bestätigt sich automatisch.`,
    perk3Title: `Aktionen und Zusatzgebühren`,
    perk3Text: `Aufenthaltsrabatte, Services und eigene Gebühren.`,
    perk4Title: `Ein Link pro Unterkunft`,
    perk4Text: `Jedes Inserat mit eigener Buchungsmaschine und Verfügbarkeit.`,
  },

  unitsList: {
    title: `Verfügbare Einheiten`,
    subtitle: `Aktivieren Sie die Einheiten, die in Ihrer Buchungsmaschine erscheinen sollen.`,
    loading: `Wird geladen…`,
    sectionUnits: `Einheiten`,
    colUnit: `Einheit`,
    colCap: `Kap.`,
    colActive: `Aktiv`,
    noUnits: `Keine Einheiten konfiguriert.`,
    active: `Aktiv`,
    inactive: `Inaktiv`,
    noticePrefix: `Aktivieren Sie Direktbuchungen unter`,
    noticeGlobalConfig: `Globale Einstellungen`,
    noticeSuffix: `, um die Einheiten zu verwalten.`,
    sectionLink: `Individueller Apartment-Link`,
    linkCardTitle: `Gefilterter Link für dieses Apartment`,
    linkCardDesc: `Öffnet dieselbe allgemeine Buchungsmaschine, zeigt aber direkt dieses Apartment.`,
    viewAsVisitor: `Als Besucher ansehen`,
    unitUpdated: `Einheit aktualisiert.`,
    updateError: `Aktualisierung nicht möglich.`,
    noLinkCopy: `Kein Link zum Kopieren.`,
    linkCopied: `Link kopiert.`,
    copyError: `Der Link konnte nicht kopiert werden.`,
    noLinkOpen: `Kein Link zum Öffnen.`,
  },

  commonAreaImages: {
    intro: `Allgemeine Fotos (Eingang, Pool, Rezeption, Garten…), die dem Gast beim Öffnen der Buchungsmaschine als Titelbild angezeigt werden, zusammen mit der Galerie jeder Einheit.`,
    imagesCount: `{count} Bild | {count} Bilder`,
    reorderHint: `Zum Sortieren ziehen · das erste ist das Titelbild`,
    reordering: `Wird sortiert…`,
    dragTitle: `Ziehen`,
    coverBadge: `Titelbild`,
    empty: `Sie haben noch keine Fotos der Gemeinschaftsbereiche hinzugefügt. Laden Sie sie oben hoch, um das Titelbild des Inserats zu erstellen.`,
    loadError: `Die Fotos der Gemeinschaftsbereiche konnten nicht geladen werden.`,
    uploadSuccess: `Fotos erfolgreich hochgeladen.`,
    uploadError: `Die Bilder konnten nicht hochgeladen werden.`,
    orderUpdated: `Reihenfolge aktualisiert.`,
    orderError: `Die Reihenfolge konnte nicht aktualisiert werden.`,
    deleteConfirmMsg: `Dieses Foto des Gemeinschaftsbereichs löschen?`,
    deleteConfirmHeader: `Bild löschen`,
    deleteAccept: `Löschen`,
    deleteReject: `Abbrechen`,
    imageDeleted: `Bild gelöscht.`,
    deleteError: `Das Bild konnte nicht gelöscht werden.`,
    coverUpdated: `Titelbild aktualisiert.`,
    coverError: `Das Titelbild konnte nicht festgelegt werden.`,
    invalidFiles: `Ungültige Dateien: {message}\n{details}`,
  },
};
